module.exports = __webpack_public_path__ + "static/media/rb-avatar-bird.4e405979.svg";